"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteApp = deleteApp;
exports.getAppList = getAppList;
exports.resetAppSecret = resetAppSecret;
exports.saveOrUpdateApp = saveOrUpdateApp;
var _request = _interopRequireDefault(require("@/utils/request"));
// 查询开放配置列表
function getAppList(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/open/list',
    method: 'get',
    params: params
  });
}

// 保存或更新开放配置
function saveOrUpdateApp(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/open/saveOrUpdate',
    method: 'post',
    data: data
  });
}

// 删除配置
function deleteApp(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/open/deleted',
    method: 'post',
    data: data
  });
}

// 重置 AppSecret
function resetAppSecret(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/open/resetAppSecret',
    method: 'post',
    data: data
  });
}